<form [formGroup]="formGroup">
  <div formArrayName="education">
    <div
      class="card-data"
      *ngFor="let edu of education.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="d-flex">
        <h4>
          {{ "Education" | translate }}
        </h4>
        <i
          *ngIf="this.education.length > 1"
          (click)="removeEducation(i)"
          class="col-auto bi bi-trash3 delete-icon"
        ></i>
      </div>
      <div class="d-flex justify-content-between">
        <div class="date">
          <label>{{ "Level of Education (Degree)" | translate }}</label>

          <input
            type="text"
            formControlName="degree"
            placeholder="{{ 'Enter your level education' | translate }}"
          />
        </div>
        <div class="date">
          <label>{{ "Major" | translate }}</label>

          <input
            type="text"
            formControlName="major"
            placeholder="{{ 'Enter your major' | translate }}"
          />
        </div>
      </div>

      <label>{{ "University Name (faculty)" | translate }}</label>

      <input
        type="text"
        formControlName="university"
        placeholder="{{ 'Enter your faculty' | translate }}"
      />

      <div class="d-flex justify-content-between">
        <div class="date">
          <label>{{ "End Date" | translate }}</label>

          <input
            type="date"
            formControlName="startDate"
            placeholder="{{ 'Select date' | translate }}"
          />
        </div>
        <div class="date">
          <label>{{ "Gradate Degree" | translate }}</label>

          <input
            type="text"
            formControlName="grade"
            placeholder="{{ 'Select gradate degree' | translate }} /GPA"
          />
        </div>
      </div>
    </div>

    <div class="card-data add-new" (click)="addEducation()">
      <h6>{{ "Add New Education" | translate }}</h6>
      <i class="bi bi-plus-circle"></i>
    </div>

    <div class="next-container px-4">
      <button class="border-button m-3" (click)="onPrevious()">
        {{ "Back" | translate }}
      </button>
      <button class="gradient-button m-3" (click)="onNext()">
        {{ "Next" | translate }}
      </button>
    </div>
  </div>
</form>
